import { Mapper } from "../../../lib/utils/mapper";
import { apiClientMainV2 } from "../../../lib/client-api";
import type { IUserSubscriptionDto } from "./dto/user-subscription.dto.interface";
import { UserSubscriptionDto } from "./dto/user-subscription.dto";
import { UserSubscriptionAccount } from "./types/user-subscription-account.entity";

const SUBSCRIPTIONS_ENDPOINT = "/subscriptions/account";

export async function getUserSubscription(): Promise<UserSubscriptionDto> {
  const response = await apiClientMainV2.get<IUserSubscriptionDto>(SUBSCRIPTIONS_ENDPOINT);
  return Mapper.mapData(UserSubscriptionDto, response.data);
}

export async function getUserSubscriptionAccount(): Promise<UserSubscriptionAccount> {
  const dto = await getUserSubscription();
  return Mapper.mapData(UserSubscriptionAccount, dto);
}
